import { useMemo } from 'react'
import { Props } from '../ExtraInfo'
import useMediaQuery from '@mui/material/useMediaQuery'
import { Theme } from '@mui/material/styles/createTheme'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

export function useData(props: Props) {
  const {
    searchItem: { createdTime },
  } = props
  const { formatDateTime } = useLocalizationDateFormat()

  const createdTimeFormatted = useMemo(
    () =>
      createdTime
        ? formatDateTime(createdTime.toString(), " 'at' h:mm aa") || ''
        : '',
    [createdTime, formatDateTime],
  )

  const isTabletOrMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  )

  return { createdTimeFormatted, isTabletOrMobile }
}
